import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaImpuestos = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "detalleItbis";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)
    const [expandir, setExpandir] = useState(false);
    
    const diferencia = (data.ventas || 0) - (data.compras || 0);

    const getData = async (anio,mes) => {
        setLoading(true);
        setExpandir(false);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            console.log(req.data);
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);


    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div style={styles.subtitulo}>
                        DETALLE DE ITBIS
                    </div>
                </div>

                <div style={{
                    ...styles.infoBlockContainer,
                    maxHeight: expandir ? '250px' : '80px'
                }} className="row">
                    {data?.ventas > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>{formatCurrency(data.ventas)}</strong>
                            </div>
                            <small style={styles.label}>Ventas</small>
                        </div>
                    )}
                    {data?.compras  > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>{formatCurrency(data?.compras)}</strong>
                            </div>
                            <small style={styles.label}>Compras</small>
                        </div>
                    )}
                    <div style={styles.infoBlock}>
                        <div>
                            <strong style={{color: diferencia > 0 ? 'red' : '#00ad5f'}}>{formatCurrency(Math.abs(diferencia))}</strong>
                        </div>
                        <small style={styles.label}>Diferencia {diferencia > 0 ? 'en contra' : 'a favor'}</small>
                    </div>

                    <div style={styles.infoBlock}>
                        <div>
                            <strong style={{color: data.isr > 0 ? 'red' : '#00ad5f'}}>{formatCurrency(Math.abs(data.isr))}</strong>
                        </div>
                        <small style={styles.label}>ISR 27% Diferencia {data.isr > 0 ? 'en contra' : 'a favor'}</small>
                    </div>

                    {!expandir && (
                        <button type="button" style={styles.expandir} onClick={() => setExpandir(true)}>Expandir</button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TarjetaImpuestos;
